"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./cv.scss");
const core_1 = require("@material-ui/core");
const Cv = (props) => {
    return (react_1.default.createElement(core_1.Box, { id: 'cv', className: `v2-container-background ${props.className}` },
        react_1.default.createElement("h4", { className: 'v2-profile-block-heading' }, "Cv & References"),
        react_1.default.createElement("div", { className: "files-wrapper" },
            react_1.default.createElement("p", { className: "file" }, "R. Paul McCauley's CV"))));
};
exports.default = Cv;
